
import Sound from '@/entities/Sound/Sound'

export default class

  # gong      # Sound
  # restDone  # Sound

  constructor: ->
    @gong     = new Sound 'gong.ogg'
    @restDone = new Sound 'whistle-rest.wav'

  getRestDone: -> @restDone

  playGong:     (volume) -> @gong.play     volume
  playRestDone: (volume) -> @restDone.play volume

  preload: ->
    @gong.preload()
    @restDone.preload()
